export const webPalette = {
  layoutUserPopover: '#FFFFFF26',
  navbar: '#101C2F',
  lightError: '#FF50A2',
  nonAuthGradient: '#1B2E4D',
  nonAuthGradientBlack: '#111111',
  selectedBlockType: '#374761'
};
